import React from "react";
import { RouteObject } from "react-router-dom";
import OrgSetupLanding from "./components/OrgSetupLanding";

export interface OrgSetupRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: OrgSetupRoute[];
}

export const orgSetupRoutes: OrgSetupRoute[] = [
  {
    path: "/onboarding/org-setup/dashoard",
    element: <OrgSetupLanding />,
  },
  {
    path: "/settings",
    element: <OrgSetupLanding />,
    auth: true,
  },
];
